export var SupplementType;
(function (SupplementType) {
    SupplementType["AcidicCalcium"] = "Acidic Calcium";
    SupplementType["AlkalineCalcium"] = "Alkaline Calcium";
    SupplementType["ColloidalCaps"] = "Colloidal Caps";
    SupplementType["BakingSoda"] = "Baking Soda";
    SupplementType["VitaminB12"] = "Vitamin B12";
    SupplementType["IonicIron"] = "Ionic Iron";
    SupplementType["Unknown"] = "Unknown";
})(SupplementType || (SupplementType = {}));
export var DosageUnits;
(function (DosageUnits) {
    DosageUnits["Teaspoons"] = "tsp";
    DosageUnits["Milligrams"] = "mg";
    DosageUnits["Pills"] = "pills";
    DosageUnits["Mcg"] = "mcg";
    DosageUnits["Drops"] = "drops";
})(DosageUnits || (DosageUnits = {}));
//# sourceMappingURL=supplements.js.map